import { Box, Divider, Typography } from '@material-ui/core';
import { FormControl } from '@mui/material';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
import styles from '../Utilisateurs.module.scss';
import { SGSCheckbox, SGSFormRadio } from 'components';
import { AlertFrequency, Roles, TypeMode, TypeRole } from 'core/models';
import { PropsWithChildren } from 'react';
import moment from 'moment';
type Props = {
    mode: TypeMode;
    lastNotification?: string;
};

export const FormAlerte: React.FC<PropsWithChildren<Props>> = ({ lastNotification, mode }) => {
    const { watch, getValues } = useFormContext();
    const wantsReceiveAlerts = watch('alertBia.actif', false);
    const watchFrequence = watch('alertBia.frequence', 0);
    const selectedAlertFrequency = AlertFrequency.find((o) => o.value === watchFrequence);

    console.log(mode);

    const hasRoleBia = () => {
        const userRights = getValues('roles');
        const userRole = getValues('role');
        return userRights.includes(Roles.ROLE_SEE_BIA) || userRole === TypeRole.ADMIN;
    };

    const formattedDate = lastNotification ? moment(lastNotification).format('DD/MM/YYYY à HH:mm') : 'Aucune';

    return (
        <>
            <Typography className={styles.SGStitle}>BIA EN ATTENTE DE VALIDATION</Typography>
            <Divider className={classNames(styles.SGSDivider, 'mb-4')} />

            <SGSCheckbox
                name="alertBia.actif"
                value={wantsReceiveAlerts}
                checked={wantsReceiveAlerts}
                label="Souhaitez-vous que l'utilisateur reçoive des alertes par e-mail ?"
                disabled={!hasRoleBia()}
            ></SGSCheckbox>

            {wantsReceiveAlerts && hasRoleBia() && (
                <FormControl>
                    <SGSFormRadio name="alertBia.frequence" options={AlertFrequency} value={selectedAlertFrequency} row />
                </FormControl>
            )}

            <Box className={styles.textNoticeGray}>
                Date dernière alerte :{' '}
                <Typography component="span" className={styles.textNoticeLightBlue}>
                    {formattedDate}
                </Typography>
            </Box>
            {!hasRoleBia() && <Box className={styles.textNotice}>L'utilisateur doit disposer du droit "BIA en ligne" pour recevoir les alertes</Box>}
        </>
    );
};
